/**
 * Формат ресурса (отчета, печатной формы, и т.п).
 */
export enum ResourceFormat {
  PDF = "PDF",

  DOCX = "DOCX",

  TXT = "TXT",
}

/**
 * Стандартный маппинг именований формата ресурсов на читаемый текст.
 */
export const RESOURCE_FORMAT_TO_TEXT = new Map([
  [ResourceFormat.PDF, "pdf"],
  [ResourceFormat.DOCX, "docx"],
  [ResourceFormat.TXT, "txt"],
]);
